import api from "./apiHelper";

export const createCheckOutSession = (payload) => {
  return api.post(`/subscription/create-checkout-session`, payload);
};

export const successfulSubscription = (session_id) => {
  return api.get(`/subscription/success?session_id=${session_id}`);
};

export const createPortalSession = (payload) => {
  return api.post(`/subscription/create-portal-session`, payload);
};

export const getUserSubscription = () => {
  return api.get(`/subscription/get-user-subscription`);
};

export const patchUserSubscription = (payload) => {
  return api.patch(`/subscription/patch-user-subscription`, payload);
};

export const cancelUserSubscription = () => {
  return api.post(`/subscription/cancel-user-subscription`);
};

export const changeUserPaymentInformation = (payload) => {
  return api.post(`/subscription/change-user-payment-information`, payload);
};

export const adminCancelUserSubscription = (payload) => {
  return api.post(`/subscription/admin-cancel-user-subscription`, payload);
};

export const assignFreeTrial = () => {
  return api.patch(`/subscription/add-one-month-free-trial`);
};

export const assignCutOffDate = (payload) => {
  return api.patch(`/subscription/assign-cut-off-date`, payload);
};

//invoices from stripe
export const getBillingListFromStripe = () => {
  return api.get(`/billing/stripe`);
};

//invoices from stripe but saved into database for caching to speed up retrieving time
export const getBillingListFromDatabase = (payload) => {
  return api.post(`/billing/database`, payload);
};

//invoice from stripe for specific user
export const getUserBillings = (customerId) => {
  return api.get(`/billing/get-user-billings?customerId=${customerId}`);
};

export const patchUserBillingDetails = (payload) => {
  return api.patch(`/billing/patch-user-billing-details`, payload);
};

export const patchUserBillingEmailRecipients = (payload) => {
  return api.patch(`/billing/patch-user-billing-email-recipients`, payload);
};

export const deleteUserBillingEmailRecipient = (payload) => {
  return api.patch(`/billing/delete-user-billing-email-recipient`, payload);
};
